function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(key => ({key, val: key}))
    : Object.keys(map).map(key => ({key, val: map[key]}))
}

export default normalizeMap



// WEBPACK FOOTER //
// ./src/lib/normalizeMap.js